import Article from "@material-symbols/svg-500/rounded/article.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const ArticleIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Article });
	return <Icon />;
};

export default memo(ArticleIcon);
